import {Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {DailyWorkReportGrid} from "./grid";
import {submitDailyWorkReport} from "../../../services/report/work";
import {CardFooterPaginator} from "../../system/cardFooterPaginator";
import FromToDateField from "../../system/fromToDateField";
import {downloadFile} from "../../../config";
import {PaginateContext} from "../../../context/paginate";

export function DailyWorkReportManagement() {

  const [dailyWorkReport, setDailyWorkReport] = useState([]);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);

  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(data, paginate) {
    const result = await submitDailyWorkReport(data, paginate);
    if (result.status === 200) {
      const {daily_work_report, total_count} = result.data;
      setDailyWorkReport(daily_work_report || []);
      setGridTotalRowCount(total_count);
    }
  }

  const filter = () => {
    const data = {}

    if (dateFrom) {
      data.date_from = dateFrom;
    }

    if (dateTo) {
      data.date_to = dateTo;
    }

    return data
  };

  useEffect(() => {
    const data = filter()
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(data, paginate)
  }, [dateFrom, dateTo, gridCurrentPage, gridRowCount, sortBy, sortType]);

  return (
    <PaginateContext.Provider value={{
      setSortBy: setSortBy,
      sortType: sortType,
      setSortType: setSortType,
      active: gridCurrentPage,
      setActive: setGridCurrentPage,
      totalRows: gridTotalRowCount,
      rowsCount: gridRowCount,
      setRowsCount: setGridRowCount,
      from: from,
      to: to,
    }}>
      <div className="w-full">
        <Card className="pt-8 w-full">
          <CardHeader floated={true} shadow={false} className="rounded-none w-full">
            <div className="mb-8 flex items-center justify-between gap-8">
              <Typography variant="h5" color="blue-gray">گزارش عملکردی روزانه</Typography>
            </div>

          </CardHeader>
          <CardBody className="w-full">

            <div className="flex flex-col md:flex-row">

              <div className="flex flex-row w-1/2 pb-4 mb-4 md:flex-col">
                <FromToDateField
                  className="w-full"
                  fromDate={dateFrom}
                  setFromDate={setDateFrom}
                  toDate={dateTo}
                  setToDate={setDateTo}
                  label="ایجاد"
                />
              </div>

            </div>

            <div className="flex flex-row justify-between">
              <Button variant="gradient" color="gray" onClick={() => {
                setDateFrom(null)
                setDateTo(null)
              }} className="ml-1">
                <span>حذف فیلتر</span>
              </Button>

              {dailyWorkReport.length > 0 &&
                <Button size="sm" variant="outlined" onClick={() => {
                  const data = filter();
                  downloadFile("daily_work_report_excel", data, "daily_works")
                }}>
                  خروجی اکسل
                </Button>
              }
            </div>

            <div className="w-full overflow-x-scroll">
              <DailyWorkReportGrid
                dailyWorkReport={dailyWorkReport}
              />
            </div>
          </CardBody>

          <CardFooterPaginator/>
        </Card>
      </div>
    </PaginateContext.Provider>
  )
    ;
}